import { set } from "lodash";

import { isNonEmpty } from "utils";
import { DEFAULT_PAGE_LIMIT } from "globals/constants";


export const baseInitialState = {
	content: {
		items: [],
		totalItems: 0,
		sort: {
			column: "",
			direction: "ascending"
		},
		paging: {
			pageNumber: 1,
			pageLimit: DEFAULT_PAGE_LIMIT
		},
		search: {},
	},
};

/**
 * * Returns data using passed function or initial value
 * @param get
 * @param initialValue
 * @returns {*|*[]}
 */
const getStoredData = (get, initialValue = []) => {
	if (!get) {
		return initialValue;
	}

	const storedData = get();

	return isNonEmpty(storedData) ? storedData : initialValue;
};

/**
 * This function allow to extend passed initialState.
 * The passed functions are called and set the value according to the passed key, if it is not empty,
 * otherwise the default passed value is set.
 */
export const initializeEntityListState = (...initializers) => initialState => {
	return initializers.reduce((acc, [key, getter, initialValue]) => {
		set(acc, key, getStoredData(getter, initialValue))

		return acc;
	}, { ...initialState });
};
